import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button, Checklist, Drawer, Field, FileField, Input } from '@itds/elements/index.js';

import { Api } from '@brokerage/utils/Api';

const Edit = ({ agency, form, onClose, onSave, show }) => {
  const params = useParams();
  const [form_tags, setFormTags] = useState([]);
  const [products, setProducts] = useState([]);

  //Added default fields for data
  const [data, setData] = useState({
    guid: null,
    agency_guid: null,
    form_name: null,
    description: null,
    pdf_file: null,
    form_tag_ids: null,
    product_guids: null,
    original_file_url: null
  });

  useEffect(() => {
    Promise.all([
      Api.loadBgaQuoters(params.agency_id),
      Api.loadFormEngines(params.agency_id),
      Api.loadFormTags()
    ]).then(response => {
      setProducts([...response[0].data, ...response[1].data]);
      setFormTags(response[2].data.data);
    });
  }, [agency]);

  useEffect(() => {
    const new_form = form || {};

    setData({
      guid: new_form.guid,
      agency_guid: new_form.agency_guid,
      form_name: new_form.form_name,
      description: new_form.description,
      pdf_file: null,
      form_tag_ids: new_form.form_tag_ids,
      product_guids: new_form.product_guids,
      original_file_url: new_form.pdf_file && new_form.pdf_file.url ? new_form.pdf_file.url : ''
    });
  }, [show]);

  const handleInputChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });
  };

  const handleFileChange = pdf_file => {
    setData({ ...data, pdf_file });
  };

  const handleChecklistChange = (name, selected) => {
    setData({ ...data, [name]: selected });
  };

  const handleSave = () => {
    window.scrollTo(0, 0);

    Api.saveAgencyForm(form.guid, data)
      .then(() => {
        onSave('success');
        onClose();
      })
      .catch(() => {
        onSave('error');
        onClose();
      });
  };

  return (
    <Drawer
      alignRight={true}
      footer={
        <Button onClick={handleSave}>{data.guid ? 'Save Changes' : 'Create Agency Form'}</Button>
      }
      onClose={onClose}
      show={show}
      title={data.guid ? 'Editing Form' : 'New Agency Form'}
    >
      <Field label='Name'>
        <Input onChange={handleInputChange.bind(null, 'form_name')} value={data.form_name} />
      </Field>
      <Field label='Decription'>
        <Input
          height={120}
          onChange={handleInputChange.bind(null, 'description')}
          style={{ fontFamily: 'Roboto, Helvetica, Arial, sans-serif' }}
          type='textarea'
          value={data.description}
        />
      </Field>

      <div style={{ marginBottom: '30px' }}>
        <Field label='PDF Form'>
          <FileField
            file={data.pdf_file}
            fileUrl={data.original_file_url}
            onChange={handleFileChange}
          />
        </Field>

        <Field label='Tags'>
          <Checklist
            onChange={handleChecklistChange.bind(null, 'form_tag_ids')}
            options={form_tags.map(p => ({ value: p.id, label: p.name }))}
            selected={data.form_tag_ids || []}
          />
        </Field>

        <Field label='Products'>
          <Checklist
            onChange={handleChecklistChange.bind(null, 'product_guids')}
            options={products.map(p => ({ value: p.guid || p.token, label: p.name }))}
            selected={data.product_guids || []}
          />
        </Field>
      </div>
    </Drawer>
  );
};

Edit.propTypes = {
  agency: PropTypes.object,
  form: PropTypes.object,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  show: PropTypes.bool
};

export default Edit;
